import { InjectionToken } from '@angular/core';

export interface Newrelic {
  addPageAcion(name: string, customAttributes?: object): void;
  addRelease(releaseName: string, releaseId: string): void;
  noticeError(error: Error, customAttributes?: object): void;
  setUserId(userId: string | null): void;
  setCustomAttribute(
    name: string,
    value: string | number | boolean | null,
    persist?: boolean
  ): void;
}

export const NEWRELIC = new InjectionToken<Newrelic>('NEWRELIC');
